import { render, staticRenderFns } from "./SportProgram.vue?vue&type=template&id=627310e2&scoped=true&"
import script from "./SportProgram.vue?vue&type=script&lang=js&"
export * from "./SportProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627310e2",
  null
  
)

export default component.exports